(() => {
    'use strict';

    const putWidgetRef = (payload, widget) => {
        const selectVal = real.form.getDataPayload(widget.find('.source-widget-ref'))['source_widget_ref'];
        if (!selectVal) {
            return;
        }
        const [sourceWidgetType, sourceWidgetId] = selectVal.split('-');
        payload.source_widget_type = sourceWidgetType;
        payload.source_widget = sourceWidgetId;
        if (payload.source_widget_ref) {
            delete payload.source_widget_ref;
        }
    }

    howspace.widgets.summary = {
        initView: widget => {
            const setSourceWidgetReference = (widget) => {
                let dataPayload = {
                    user_prompt: widget.find('[name="user_prompt"]').val(),
                }
                putWidgetRef(dataPayload, widget);
                real.ajax.json(real.baseUri + '/api/widget/summary/' + widget.data('widget-id'), {
                    type: 'POST',
                    data: JSON.stringify(dataPayload),
                });
            }
            widget.find('.save-btn').on('click', () => {
                setSourceWidgetReference(widget);
            });

            if (widget.find('.summary-container').data('requires-new-content')) {
                // Trigger the summary AI process.
                howspace.aiGen.setPromptTimeout(widget);
                real.ajax.json(real.baseUri + '/api/ai/summary/start/' + widget.data('widget-id'), {
                    type: 'POST',
                    data: JSON.stringify([]),
                    error: (response) => {
                        howspace.components.summary.update(widget.find('.howspace-summary'), howspace.translate('summary_prompt_failed'));
                        howspace.aiGen.clearPromptTimeout(widget);
                    }
                });
            }

        },
        destroyView: widget => {
            // Empty for now.
        },
        initEdit: widget => {
            // Empty for now.
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        save: (widget, dataPayload) => {
            putWidgetRef(dataPayload, widget);
            return dataPayload;
        },
        updateFilter: widget => {
            console.log('Update filter for summary widget is not implemented.');
        },
    };
})();
